import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const supportStatusOptions = [
  { label: 'Não respondido', value: 'not_responded' },
  { label: 'Em andamento', value: 'in_progress' },
  { label: 'Resolvido', value: 'closed' },
]

export const supportStatusStrategy = optionsToStrategy(supportStatusOptions)
